import { Box, ChakraProvider, ChakraProviderProps } from '@chakra-ui/react';
import { FC, PropsWithChildren, useRef } from 'react';

import { useThemeFonts } from '../hooks/use-theme-fonts';
import { createTheme, Extension, theme } from '../theme';

export interface ThemeProviderProps extends ChakraProviderProps, PropsWithChildren {
	__overrides?: Extension;
	disableReset?: boolean;
}

const createId = () => 'theme-' + (Date.now() * Math.random()).toString(16).split('.')[0];

const ThemeProvider: FC<ThemeProviderProps> = ({ __overrides, disableReset = false, children, ...rest }) => {
	useThemeFonts();

	const idRef = useRef(createId());

	if (!__overrides) {
		return (
			<ChakraProvider theme={theme} resetCSS={!disableReset} {...rest}>
				{children}
			</ChakraProvider>
		);
	}

	return (
		<Box id={idRef.current}>
			<ChakraProvider cssVarsRoot={`#${idRef.current}`} theme={createTheme(__overrides)} resetCSS={!disableReset} {...rest}>
				{children}
			</ChakraProvider>
		</Box>
	);
};

ThemeProvider.displayName = 'ThemeProvider';

export { ThemeProvider };
